import React, { useEffect, useRef } from "react";

export default function Selectric(props) {

    const { defaultValue,
        id,
        onChange } = props;

    const selectEl = useRef(null);

    const handleChange = function (e) {
        onChange(e.target.value);
    }

    useEffect(() => {
        const $el = $(selectEl.current);
        $el.selectric({
            disableOnMobile: false,
            nativeOnMobile: false
        });
        $el.on('change', handleChange);

        return function cleanup() {
            $el.off('change', handleChange);
            $el.selectric('destroy');
        }
    }, []);

    return (
        <div>
            <select ref={selectEl} defaultValue={defaultValue} id={id}>
                {props.children}
            </select>
        </div>
    );
}